module.exports = __webpack_public_path__ + "img/www.direct.com.1ab90146.png";